import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { CycleRecommendationQueriesConfig } from './cycle-recommendation.queries';
export const CycleRecommendationApiClient = createApiClient(CycleRecommendationQueriesConfig);
//# sourceMappingURL=cycle-recommendation.api-client.js.map